import React from 'react'
import css from '@emotion/css'
import styled from '@emotion/styled'
import { Button } from '@material-ui/core'
import { colors, widths, breakpoints, fonts } from '../../../styles/variables'
import { getEmSize } from '../../../styles/mixins'

const Title = styled.h2`
  color: ${colors.darkBlue};
  margin-bottom: 30px;
  font-size: 40px;
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }
`

const Container = styled.div`
  background-color: ${colors.white};
  padding: 60px;
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    padding: 20px;
  }
`

const AmountsList = styled.div`
  display: flex;
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    flex-direction: column;
  }
`
const AmountButton = styled(Button)`
  margin-right: 40px;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 40px;
  padding-right: 40px;
  color: ${colors.white};
  font-family: ${fonts.sansSerif};
  font-weight: 900;
  font-size: 20px;
  letter-spacing: 0.1em;
  background-color: ${colors.red};
  &:hover,
  &:focus {
    background-color: ${colors.darkRed};
  }
  @media (max-width: ${getEmSize(breakpoints.lg)}em) {
    margin-bottom: 20px;
    margin-right: auto;
    margin-left: auto;
    min-width: 150px;
  }
`

export default function Contribute() {
  return (
    <Container>
      <Title>Contribute</Title>
      <AmountsList>
        <AmountButton href="https://secure.actblue.com/donate/justin-jones-for-congress-1?amount=3">$3</AmountButton>
        <AmountButton href="https://secure.actblue.com/donate/justin-jones-for-congress-1?amount=16">$16</AmountButton>
        <AmountButton href="https://secure.actblue.com/donate/justin-jones-for-congress-1?amount=27">$27</AmountButton>
        <AmountButton href="https://secure.actblue.com/donate/justin-jones-for-congress-1?amount=50">$50</AmountButton>
        <AmountButton href="https://secure.actblue.com/donate/justin-jones-for-congress-1">OTHER AMOUNT</AmountButton>
      </AmountsList>
    </Container>
  )
}
